import { config } from '../config'

export const webappRoutes = {
  notifications: {
    path: `/${config.domainName}/config`,
  },
}
